var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("p", {
        staticClass: "q-body-1 text-center",
        domProps: { textContent: _vm._s(_vm.$t("text.myTickets")) }
      }),
      _c("q-btn", {
        directives: [
          {
            name: "track-click",
            rawName: "v-track-click:button",
            value: { category: "Navegação", label: "Meus Eventos" },
            expression: "{category: 'Navegação', label: 'Meus Eventos'}",
            arg: "button"
          }
        ],
        staticClass: "full-width",
        attrs: {
          color: _vm.SET_COLOR_BUTTON.primary,
          "text-color": _vm.SET_COLOR_BUTTON.text.primary,
          label: _vm.$t("button.myEvents")
        },
        on: {
          click: function($event) {
            _vm.$router.replace(_vm.to)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }